function Listitem(props) {
    var mylist = props.mylist
    var setmylist = props.setmylist
    function handleDelete(deleteid){
        var temparr = mylist.filter(function(item){
            if(item.id===deleteid){
                return false
            }
            else{
                return true
            }
        })
        setmylist(temparr)
    }
    
    return (<li className="list-decimal">
        <div className="flex justify-between"><span>{props.activity}</span><button onClick={()=>{handleDelete(props.id)}}><i className="fa-solid fa-trash" style={{ color: "#ed0202" }}></i></button>
        </div>
    </li>)
}
export default Listitem